"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const AreaCode_1 = __importDefault(require("@App/kit/fields/v2/PhoneNumberForm/AreaCode"));
const LineNumber_1 = __importDefault(require("@App/kit/fields/v2/PhoneNumberForm/LineNumber"));
const contexts_1 = require("@App/contexts");
const form_field_1 = require("@App/forms/v2/common/form-field");
const DropdownForm_1 = __importDefault(require("@App/kit/fields/v2/DropdownForm"));
const mobx_react_1 = require("mobx-react");
const PhoneNumberForm = (props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const phoneNumberFormFields = props.phoneNumberFormFields;
    const [phoneCountryCode, setPhoneCountryCode] = (0, react_1.useState)(phoneNumberFormFields.phoneCountryCode);
    const setPhoneCountryCodeOptions = () => {
        setPhoneCountryCode(Object.assign(Object.assign({}, phoneCountryCode), { options: libStore.phoneCountryCodes }));
    };
    (0, react_1.useEffect)(() => {
        setPhoneCountryCodeOptions();
    }, []);
    return (react_1.default.createElement("div", { className: "phone-number-form-component" },
        react_1.default.createElement("label", { className: "small main-phone-label" }, "Phone Number"),
        react_1.default.createElement("div", { className: "phone-inputs-block" },
            react_1.default.createElement("div", { className: "phone-country-code" },
                react_1.default.createElement(DropdownForm_1.default, Object.assign({}, phoneCountryCode))),
            phoneNumberFormFields.phoneAreaCode && (0, form_field_1.isFormFieldProp)(phoneNumberFormFields.phoneAreaCode) && (react_1.default.createElement(AreaCode_1.default, Object.assign({}, phoneNumberFormFields.phoneAreaCode))),
            (0, form_field_1.isFormFieldProp)(phoneNumberFormFields.phoneNumber) && (react_1.default.createElement(LineNumber_1.default, Object.assign({}, phoneNumberFormFields.phoneNumber))))));
};
exports.default = (0, mobx_react_1.observer)(PhoneNumberForm);
